import { AxiosError, AxiosResponse } from "axios";
import { QueryKey, UseQueryOptions } from "react-query";

import { axiosChartInstance } from "config";
import { useAxiosQuery } from "hooks";
import { ChartApplicationStatus } from "modules/charts-shared/types";
import { ChartType } from "types";

type UseActiveChartsResponseItem = {
  chartApplicationId: string;
  chartCode: string;
  chartTitle: string;
  chartType: ChartType;
  chartStatus: ChartApplicationStatus;
};

function useActiveCharts(
  encounterId: string,
  options?: UseQueryOptions<
    AxiosResponse<UseActiveChartsResponseItem[]>,
    AxiosError,
    AxiosResponse<UseActiveChartsResponseItem[]>,
    QueryKey
  >
) {
  return useAxiosQuery(
    ["activeCharts", { encounterId }],
    () =>
      axiosChartInstance.get<UseActiveChartsResponseItem[]>(
        `v1/chart-application/${encounterId}`
      ),
    options
  );
}

export type { UseActiveChartsResponseItem };
export { useActiveCharts };
